/* AnnaluciaDesign V78 - Height of product photo follows the visible purchase/status panel.
   No changes to inventory, checkout, Shopify media or restock functionality. */
(function () {
  'use strict';
  if (window.__alGalleryFitV78) return;
  window.__alGalleryFitV78 = true;

  function visible(el) {
    if (!el || !el.isConnected || !el.getClientRects().length) return false;
    const box = el.getBoundingClientRect();
    if (box.height < 2 || box.width < 2) return false;
    for (let node = el; node && node.nodeType === 1; node = node.parentElement) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }
  function pick(root, selectors) {
    for (const selector of selectors) {
      const nodes = root.querySelectorAll(selector);
      for (const node of nodes) if (visible(node)) return node;
    }
    return null;
  }
  function preferenceNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }
  function init(hero) {
    if (hero.__alFitStarted) return;
    hero.__alFitStarted = true;
    let frame = null;
    let lastGallery = null;
    let lastInfo = null;
    let resizeObserver = null;
    const media = window.matchMedia('(min-width: 1000px)');

    function schedule() {
      if (frame !== null) return;
      frame = requestAnimationFrame(function () { frame = null; update(); });
    }
    function resetGallery(gallery) {
      if (!gallery) return;
      gallery.removeAttribute('data-al-fit-ready');
      gallery.style.removeProperty('--al-fit-target-height');
    }
    function attachObservers(gallery, info) {
      if (gallery === lastGallery && info === lastInfo) return;
      if (resizeObserver) resizeObserver.disconnect();
      lastGallery = gallery;
      lastInfo = info;
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(schedule);
        if (info) resizeObserver.observe(info);
        // Observe column WIDTH only to prevent resize loops with frame height.
        const col = hero.querySelector('.product');
        if (col) resizeObserver.observe(col);
      }
    }
    function update() {
      const gallery = hero.querySelector('.al-cashmere-gallery');
      const galleryMain = gallery?.querySelector('.al-cashmere-gallery__main');
      const info = hero.querySelector('.product-info');
      if (!gallery || !galleryMain || !info) return;
      if (!media.matches || hero.dataset.alGalleryFit !== 'true') {
        resetGallery(gallery);
        return;
      }
      attachObservers(gallery, info);
      const soldOutButton = pick(info, ['.buy-buttons button[disabled]', '[data-block-type="buy-buttons"] button[disabled]']);
      const hasAvailableBuy = !!pick(info, ['.buy-buttons button[type="submit"]:not([disabled])']);
      const soldOut = !!soldOutButton && !hasAvailableBuy;
      const payment = [
        '.shopify-payment-button__button',
        '.shopify-payment-button shop-pay-wallet-button',
        '.shopify-payment-button iframe',
        '.shopify-payment-button > div:first-child'
      ];
      const buy = ['.buy-buttons button[type="submit"]:not([disabled])'];
      const benefits = ['.al-cashmere-benefits'];
      let target;
      if (soldOut) {
        const desired = hero.dataset.alFitSold || 'benefits';
        const candidates = desired === 'notify'
          ? ['.al-cashmere-restock__trigger', ...benefits]
          : desired === 'sold_out'
            ? ['.buy-buttons button[disabled]', ...benefits]
            : [...benefits, '.al-cashmere-restock__trigger', '.buy-buttons button[disabled]'];
        target = pick(info, candidates);
      } else {
        const desired = hero.dataset.alFitStock || 'shop_pay';
        const candidates = desired === 'benefits'
          ? [...benefits, ...payment, ...buy]
          : desired === 'add_to_cart'
            ? [...buy, ...payment, ...benefits]
            : [...payment, ...buy, ...benefits];
        target = pick(info, candidates);
      }
      if (!target) { resetGallery(gallery); return; }
      const base = galleryMain.getBoundingClientRect().top;
      const end = target.getBoundingClientRect().bottom;
      const offset = preferenceNumber(soldOut ? hero.dataset.alFitSoldOffset : hero.dataset.alFitStockOffset, 0);
      const minimum = Math.max(100, preferenceNumber(hero.dataset.alFitMin, 280));
      const maximum = Math.max(minimum, preferenceNumber(hero.dataset.alFitMax, 900));
      const height = Math.round(Math.min(maximum, Math.max(minimum, end - base + offset)));
      if (!Number.isFinite(height)) { resetGallery(gallery); return; }
      if (gallery.style.getPropertyValue('--al-fit-target-height') !== height + 'px') {
        gallery.style.setProperty('--al-fit-target-height', height + 'px');
      }
      gallery.setAttribute('data-al-fit-ready', 'true');
    }
    const rerender = hero.querySelector('product-rerender');
    if ('MutationObserver' in window && rerender) {
      const mutationObserver = new MutationObserver(function (records) {
        if (records.some(function (record) { return record.type === 'childList'; })) schedule();
      });
      mutationObserver.observe(rerender, {childList: true, subtree: true});
    }
    window.addEventListener('resize', schedule, {passive: true});
    if (media.addEventListener) media.addEventListener('change', schedule);
    hero.addEventListener('change', schedule);
    schedule();
    window.addEventListener('load', schedule, {once: true});
    // Dynamic checkout (Shop Pay) can be inserted after initial theme render.
    window.setTimeout(schedule, 450);
    window.setTimeout(schedule, 1800);
  }
  function start() {
    document.querySelectorAll('.al-cashmere-main .annalucia-cashmere-hero[data-al-gallery-fit="true"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
